import { escapeHtml } from '../utils/html'

interface ReleaseListItemTemplateInput {
	index: number
	releaseId: number
	isFavorite: boolean
	isHidden: boolean
	coverSrc: string
	largeCoverSrc: string
	coverPlaceholderSrc: string
	hiddenUntil: string
	title: string
	artists: string
	defaultInfo: string
	masterYear: string
	dateAddedLabel: string
	dateAdded: string
	lastHeardLabel: string
	lastHeard: string
	favoriteLabel: string
}

export function releaseListItemTemplate({
	index,
	releaseId,
	isFavorite,
	isHidden,
	coverSrc,
	largeCoverSrc,
	coverPlaceholderSrc,
	hiddenUntil,
	title,
	artists,
	defaultInfo,
	masterYear,
	dateAddedLabel,
	dateAdded,
	lastHeardLabel,
	lastHeard,
	favoriteLabel,
}: ReleaseListItemTemplateInput): string {
	return `
        <li class="release" tabindex="0" role="button" aria-label="${escapeHtml(`${title} — ${artists}`)}" data-index="${index}" data-release-id="${releaseId}" data-is-hidden="${isHidden}">
            <div class="release-image-container">
                <img alt="" src="${escapeHtml(coverSrc)}"${largeCoverSrc ? ` data-large-src="${escapeHtml(largeCoverSrc)}"` : ''} onerror="this.src='${coverPlaceholderSrc}'" />
                ${
					isFavorite
						? `<span class="release-favorite-indicator" role="img" aria-label="${favoriteLabel}" title="${favoriteLabel}"><svg aria-hidden="true"><use href="#symbols-heart"></use></svg></span>`
						: ''
				}
                <div class="release-image-overlay">
                    <span class="hide-icon-header"><svg><use href="#symbols-eye-closed"></use></svg></span>
                    <span class="release-hidden-duration">${hiddenUntil}</span>
                </div>
            </div>
            <ul class="release-infos">
                <li class="release-title">${escapeHtml(title)}</li>
                <li class="release-artist">${escapeHtml(artists)}</li>
                <li class="release-default release-summary">${escapeHtml(defaultInfo)}</li>
                <li class="release-default"><span>Master year:</span> <span data-master-year>${masterYear}</span></li>
                ${dateAdded ? `<li class="release-default"><span>${dateAddedLabel}</span> ${dateAdded}</li>` : ''}
                ${lastHeard ? `<li class="release-default"><span>${lastHeardLabel}</span> ${lastHeard}</li>` : ''}
            </ul>
        </li>
    `
}

export function releaseListGroupHeaderTemplate(
	group: {
		key: string
		label: string
	},
	id: string,
): HTMLLIElement {
	const item = document.createElement('li')
	item.id = id
	item.className = 'release-list-group'
	item.dataset.releaseGroup = group.key
	item.tabIndex = -1

	const label = document.createElement('span')
	label.textContent = group.label
	item.append(label)

	return item
}
